import axiosInstance from '../../api/axios';

const baseUrl = '/courses';

const CourseService = {
  listAllCourses: async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/all`);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      throw error;
    }
  },
    getCoursesByUserEducationalLevel: async () => {
    try {
      const response = await axiosInstance.get(baseUrl);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      throw error;
    }
  },

  showCourseDetails: async (id) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/${id}`);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      throw error;
    }
  },

  createNewCourse: async (courseData, imageFile) => {
    try {
        const formData = new FormData();
        formData.append('image', imageFile);
        for (const key in courseData) {
            formData.append(key, courseData[key]);
        }

        const response = await axiosInstance.post(baseUrl, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.message);
        }
    } catch (error) {
        throw error;
    }
},


updateCourseDetails: async (id, courseData, imageFile) => {
  try {
      const formData = new FormData();
      if (imageFile) {
          formData.append('image', imageFile);
      }
      for (const key in courseData) {
          formData.append(key, courseData[key]);
      }

      for (let pair of formData.entries()) {
          console.log(pair[0] + ': ' + pair[1]);
      }

      const response = await axiosInstance.post(`${baseUrl}/${id}`, formData, {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      });

      if (response.data.success) {
          return response.data.data;
      } else {
          throw new Error(response.data.message);
      }
  } catch (error) {
      throw error;
  }
},

  deleteCourse: async (id) => {
    try {
      const response = await axiosInstance.delete(`${baseUrl}/${id}`);
      if (response.status === 204) {
        return { success: true };
      } else if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      throw error;
    }
  },

  getAllEducationalLevels: async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/educational-levels`);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      throw error;
    }
  },
  getAllCategories: async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/categories`);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      throw error;
    }
  },
  uploadAudio: async (audioData) => {
    try {
        const formData = new FormData();
        formData.append('file', audioData.file);
        formData.append('upload_id', audioData.upload_id);
        formData.append('lang', audioData.lang);

        const response = await axiosInstance.post(`${baseUrl}/media/upload-audio`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.data.message === 'Audio upload started') {
            return response.data.track;
        } else {
            throw new Error(response.data.message);
        }
    } catch (error) {
        throw error;
    }
},
  deleteMuxAsset: async (uploadId) => {
    try {
      const response = await axiosInstance.delete(`${baseUrl}/deleteAsset`, {
        data: { upload_id: uploadId }
      });
      if (response.data.message === 'Asset deleted successfully') {
        return response.data;
      } else {
        throw new Error(response.data.error);
      }
    } catch (error) {
      throw error;
    }
  },
  fetchUploadUrl: async (index) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/create-direct-upload`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = response.data;
      // console.log('URL de téléchargement:', data.data.url);
      if (data.data && data.data.url) {
        // console.log('ID de téléchargement:', data.data.id);
        return { url: data.data.url, id: data.data.id };
      } else {
        throw new Error('Échec de la récupération de l\'URL de téléchargement');
      }
    } catch (error) {
      // console.error('Erreur lors de la récupération de l\'URL de téléchargement:', error);
      throw error;
    }
  },
  deleteAudio: async (trackId) => {
    try {
      const response = await axiosInstance.delete(`${baseUrl}/media/audio/${trackId}`);
      if (response.data.message === 'Audio track deleted successfully') {
        return response.data;
      } else {
        throw new Error(response.data.error);
      }
    } catch (error) {
      throw error;
    }
  },
};

export default CourseService;